// import AdminLayout from "../../../Layout/AdminLayout";
import PrefixForm from "./modules/PrefixForm";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import {
  useEditPrefixMutation,
  selectPrefixById,
  useGetPrefixesQuery,
} from "../../../store/admin/settings/companyPrefixSlice";
import { useSelector } from "react-redux";
import { useUser } from "../../../hooks";
import { ButtonComp } from "../../../components";

const EditCompanyPrefix = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const user = useUser();
  const { isLoading: isLoadingPrefixes } = useGetPrefixesQuery();
  const prefix = useSelector((state) => selectPrefixById(state, id));
  const initialValues = {
    name: prefix?.name || "",
    count: prefix?.count || "",
    auto_generate: prefix?.auto_generate || false,
  };
  const [editPrefix, { isLoading: isSubmittingForm }] = useEditPrefixMutation();

  const handleBack = () => {
    navigate("/super_admin/settings/company_prefix");
  };

  const handleFormSubmit = async (formValues, { setSubmitting, resetForm }) => {
    // Remove branch_id - backend will use active branch automatically
    const reqBody = {
      ...formValues,
      count: Number(formValues.count),
      auto_generate: formValues.auto_generate || false,
      prefixId: String(id),
    };
    // console.log(reqBody);
    const toastId = toast.loading("Processing...");
    try {
      const payload = await editPrefix(reqBody).unwrap();
      if (payload.status === false) {
        toast.error(payload.message || "An error occured", {
          id: toastId,
        });
      }
      if (payload.status === true) {
        toast.success(payload.message || "Success", {
          id: toastId,
        });
        // Navigate back to prefix list after successful update
        setTimeout(() => {
          navigate("/super_admin/settings/company_prefix");
        }, 500);
      }
    } catch (error) {
      toast.error(error?.message || error.data?.message || "An error occured", {
        id: toastId,
      });
      // console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="px-2 px-lg-4 min-vh-100">
      <div className="py-4"></div>
      <div className="mb-4 d-flex justify-content-between align-items-center">
        <h4 className="text-black1 fw-bold mb-0">{"Edit Prefix"}</h4>
        <ButtonComp
          btnText="Back"
          onClick={handleBack}
          btnClassName="bg-secondary py-2 px-4 rounded text-white border-0"
        />
      </div>
      {isLoadingPrefixes ? (
        <div className="py-4">
          <p>Loading...</p>
        </div>
      ) : (
        <PrefixForm
          initialValues={initialValues}
          handleFormSubmit={handleFormSubmit}
          activeBranchName={prefix?.branch?.name || user?.active_branch?.name || user?.branch?.name || "Current Branch"}
          isSubmitting={isSubmittingForm}
        />
      )}
    </section>
  );
};

export default EditCompanyPrefix;
